import { useCurrentTeamMember } from '@/providers/TeamMemberProvider';
import { useNavState } from '@/providers/NavStateProvider';
import { useEffect } from 'react';
import { useCurrentPaymentTask } from '@/providers/PaymentTaskProvider';
import { ScrollTop } from '@/components/element/ScrollTop';
import { WorkspaceLayout } from '@/components/layout/WorkspaceLayout';
import { useParams } from 'react-router-dom';
import { PaymentTaskOrderAllocatedExpenseEditForm } from '@/components/features/tasks/payment/[payment_task_id]/PaymentTaskOrderAllocatedExpenseEditForm';

export const BackofficePaymentTaskOrderAllocatedExpenses = () => {
  const { _w_, _t_, me } = useCurrentTeamMember();
  const { setTitle, setBreadcrumbs } = useNavState();
  const { purchase_order_id } = useParams();
  const { paymentTask: task } = useCurrentPaymentTask();
  useEffect(() => setTitle(`プロジェクト別按分金額の投入`), []);
  useEffect(
    () =>
      setBreadcrumbs([
        { label: `支払タスク一覧`, path: `/w/${_w_!.identifier}/backoffice/payment_tasks` },
        {
          label: `支払タスク詳細`,
          path: `/w/${_w_!.identifier}/backoffice/teams/${_t_!.id}/purchase_orders/${purchase_order_id}/payment_tasks/${
            task!.id
          }`,
        },
      ]),
    []
  );

  return (
    <WorkspaceLayout>
      <ScrollTop />

      <PaymentTaskOrderAllocatedExpenseEditForm />
    </WorkspaceLayout>
  );
};
